// Automatically use local backend if on localhost, otherwise use production backend
export const API =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
        ? "http://localhost:5000/api"
        : "https://newbackend.infoethiopia.net/api";
